module.exports = __webpack_public_path__ + "static/img/headers.bae6b4f3.gif";